module.exports = __webpack_public_path__ + "static/media/clean3.2bdaaa5e.jpg";